<div class="text-base-bold" [ngClass]="{ 'no-top-padding': !topPadding }">
  <ng-content></ng-content>
</div>
